<script>
import { mapGetters, mapState } from 'vuex'
import ListView from '@/components/common/ListView'
import UserDetail from '@/components/user-management/UserDetail'
import moment from 'moment'
import u from '@/utils'
import { userApi } from '../../api'

export default {
  data() {
    return {
      title: 'Users',
      binFile: null,
      showBulkImportInterface: false,
      bulkUserUploadLoader: false,
      excelUploadLoader: false,
      searchAttributes: ['hexId', 'username'],
      selectedHoneyUser: null,
      initialFetchUpdating: false,
      refreshFetchUpdating: false,
      deleteUpdating: false,
      page: 1,
      totalPages: 0,
      pagination: {},
      base64EncFilter: '',
      totalItems: '',
      routeName: 'user-list',
      honeyUsers: []
    }
  },

  computed: {
    ...mapState({
      // honeyUsers: state => state.honeyUsers.honeyUsers
    }),
    ...mapGetters({
      can: 'can'
    }),
    updating() {
      return (
        this.initialFetchUpdating ||
        this.refreshFetchUpdating ||
        this.deleteUpdating
      )
    }
  },

  watch: {
    selectedHoneyUser() {
      this.routeEdit()
    },
    honeyUsers() {
      this.getSelectedFromRoute()
    },
    async $route(to, from) {
      if (to.name === this.routeName && from.name === 'user-detail') return
      const obj = this.getFiltersFromUrl()
      if (obj) {
        const filter = this.createFilters(obj)
        await this.makeApiCall(filter)
      }
    }
  },

  methods: {
    async uploadUpdateExcelFile() {
      this.excelUploadLoader = true
      this.binFile = this.$refs.updateExcelInput.files[0]
      this.excelUploadLoader = false
    },

    importUser() {
      this.showBulkImportInterface = true
    },
    async bulkUploadUser() {
      this.bulkUserUploadLoader = true
      try {
        let uploadResult = await this.$store.dispatch(
          'createBulkUser',
          this.binFile
        )
        if (uploadResult === true) {
          await this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Users created successfully',
            description: `Bulk user creation requested successfully completed`,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } else {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message:
              'Users creation failed. User email or role is not present in the excel file for some rows. Kindly check and update the excel file and try again.',
            description: `Bulk user creation request failed`,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
        this.selectedBot = null
        this.routeEdit()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Users created failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.bulkUserUploadLoader = false
      this.showBulkImportInterface = false
    },
    routeEdit() {
      if (this.selectedHoneyUser) {
        this.$router.replace({
          name: 'user-detail',
          params: { hexId: this.selectedHoneyUser.hexId }
        })
      } else {
        this.$router.replace({
          name: this.routeName,
          query: { filter: this.base64EncFilter }
        })
      }
    },

    getFiltersFromUrl() {
      const params = u.checkUrlHasFilters(this.$route)
      let obj
      if (params) {
        obj = {}
        this.page = +params.get('page')
        obj.page = +params.get('page')
      }
      if (params && params.has('search')) {
        obj.search = params.get('search')
      }
      if (params && params.has('sort')) {
        const sortStr = params.get('sort').split(',')
        obj.sortBy = sortStr[0]
        obj.sortOrder = sortStr[1]
      }
      this.pagination = obj
      return obj
    },

    createFilters(obj) {
      let search = null
      let sortBy
      let sortOrder
      if (obj) {
        if (obj.page) {
          this.page = obj.page
        }
        if (obj.search) {
          search = obj.search
        }
        if (obj.sortBy) {
          sortBy = obj.sortBy
          sortOrder = obj.sortOrder
        }
      }
      let filter = `?page=${this.page}&size=10`
      if (search) {
        filter = filter + `&search=${search}`
      }
      if (sortBy) {
        filter = filter + `&sort=${sortBy},${sortOrder}`
      }
      return filter
    },

    async makeApiCall(filter) {
      try {
        this.refreshFetchUpdating = true
        const { data } = await userApi.fetchUsers(filter)
        if (data) {
          let userList = data._embedded.honeyUsers
          this.honeyUsers = userList.map(form => u.processResp(form))
          this.totalPages = data.page.totalPages
          this.totalItems = data.page.totalElements
        }

        this.refreshFetchUpdating = false
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Fetching users failed',
          description:
            'Fetching users failed - ' + e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },

    async refreshItem(obj, replace = false) {
      const filter = this.createFilters(obj)
      const condenseURL = btoa(filter)
      this.base64EncFilter = condenseURL
      if (replace || (obj && obj.replace)) {
        this.$router.replace({
          query: { filter: condenseURL },
          name: this.routeName
        })
        if (obj && obj.replace) {
          await this.makeApiCall(filter)
        }
      } else {
        this.$router.push({
          query: { filter: condenseURL },
          name: this.routeName
        })
      }
    },

    getSelectedFromRoute() {
      if (this.$router.currentRoute.name === 'user-detail') {
        this.selectedHoneyUser = this.honeyUsers.find(honeyUser => {
          return honeyUser.hexId === this.$route.params.hexId
        })
      }
    }
  },

  async created() {
    if (this.$route.name === this.routeName) {
      const obj = this.getFiltersFromUrl()
      if (obj) {
        await this.makeApiCall(this.createFilters(obj))
      } else {
        this.refreshItem(obj, true)
      }
    } else {
      this.getSelectedFromRoute()
    }
  },

  components: {
    UserDetail,
    ListView
  }
}
</script>
<template>
  <div>
    <list-view
      v-model="selectedHoneyUser"
      :items="honeyUsers"
      :search-attributes="searchAttributes"
      :title="title"
      :updating="updating"
      create-action
      item-key="hexId"
      refresh-action
      search
      @create="importUser"
      @refresh="obj => refreshItem(obj)"
      :pagefromUrl="page"
      :totalPages="totalPages"
      :totalItems="totalItems"
      :pagination="pagination"
    >
      <template slot="list-item" slot-scope="slotProps">
        <v-list-tile-avatar>
          <vue-letter-avatar
            :name="slotProps.item.username"
            :rounded="true"
            size="40"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="slotProps.item.username" />
          <v-list-tile-sub-title
            >{{ slotProps.item.createdAtLocal }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </template>

      <user-detail
        v-if="slotProps.item != null"
        slot="list-item-detail"
        slot-scope="slotProps"
        :honey-user="slotProps.item"
      />
    </list-view>
    <v-dialog v-model="showBulkImportInterface" max-width="60%">
      <template>
        <v-card>
          <v-toolbar card class="elevation-2" dense>
            <v-toolbar-title class="body-2 beez-bold ">
              Bulk Upload Users
            </v-toolbar-title>
            <v-layout align-center justify-end>
              <v-btn flat icon @click.stop="showBulkImportInterface = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-toolbar>
          <v-progress-linear
            :active="excelUploadLoader || bulkUserUploadLoader"
            class="ma-0"
            color="accent"
            height="5"
            indeterminate
          />
          <v-layout class="beez-padding" row wrap>
            <v-flex xs12>
              <div class="v-input">
                <v-btn
                  class="text-capitalize"
                  color="secondary"
                  flat
                  @click="$refs.updateExcelInput.click()"
                >
                  <v-icon>
                    cloud_upload
                  </v-icon>
                  <span>&nbsp; Upload the Bulk User Excel file</span>
                </v-btn>
                <input
                  v-show="false"
                  ref="updateExcelInput"
                  accept=".xlsx"
                  type="file"
                  @change="uploadUpdateExcelFile"
                />
              </div>
            </v-flex>
            <v-flex v-if="binFile" lg3 md6 xs12>
              <v-card
                :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                style="border-radius: 5px"
              >
                <v-toolbar flat>
                  <div>Bulk User Upload</div>
                  <v-spacer></v-spacer>
                  <v-icon>attachment</v-icon>
                </v-toolbar>
                <v-card-title primary-title>
                  <div>
                    <div class="subheading">File name: {{ binFile.name }}</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div>
                    <div class="text-xs-left body-1">
                      File size (in Bytes): {{ binFile.size }}
                    </div>
                    <div class="text-xs-left caption">
                      Last modified date: {{ binFile.lastModifiedDate }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                :class="!$vuetify.dark ? 'secondary' : ''"
                :color="$vuetify.dark ? 'secondary' : ''"
                :disabled="!binFile"
                :loading="bulkUserUploadLoader"
                :outline="$vuetify.dark"
                class="text-capitalize"
                @click="bulkUploadUser"
                >Create Users
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>
